'use strict'

module.exports = {
  moveSync: require('./move-sync')
}



//////////////////
// WEBPACK FOOTER
// ./packages/truffle-compile/~/fs-extra/lib/move-sync/index.js
// module id = 2707
// module chunks = 0 1